import React from 'react';

import LoginContainer from '@Containers/Login/Login.container';

const LoginPage: React.FunctionComponent = (): JSX.Element => (
  <LoginContainer />
);

export default LoginPage;
